import React from 'react';
import {Routes as RouterRoutes, Route} from 'react-router';
import {PreCruiseProvider} from "../../context/PreCruiseContext";
import PassengerOverview from "../passengerInformation/PassengerOverview";
import PassengersOverview from "../passengerInformation/PassengersOverview";
import PassengerFormPage from "../passengerInformation/PassengerFormPage";
import PassengerReview from "../passengerInformation/PassengerReview";
import CovidSurvey from "../../components/passengerInformation/CovidSurvey";
import AuthRoute from "../../components/routing/AuthRoute";
import CardCapturePage from "../pxp/CardCapturePage";
import PassportInfoDashboard from "../apis/PassportInfoDashboard";
import PassportInfoForm from "../apis/PassportInfoForm";
import { t } from "@lingui/core/macro";
import ImmigrationCheck from '../../components/passengerInformation/ImmigrationCheck';
import PassengerLockByEmailForm from '../passengerInformation/PassengerLockByEmailForm';
import PassengerUnlockByOtp from '../passengerInformation/PassengerUnlockByOtp';

function PrecruiseRoutes() {
    return (
        <PreCruiseProvider>
            <RouterRoutes>
                <Route index element={<AuthRoute component={Default} />} />
                <Route path={t({id: "/passengers/:type?"})} element={<AuthRoute component={PassengersOverview} />} />
                <Route path={t({id: "/passportDashboard"})} element={<AuthRoute component={PassportInfoDashboard} />} />
                <Route path={t({id: "/passport/:passengerId"})} element={<AuthRoute component={PassportInfoForm} />} />
                <Route path={t({id: "/passenger/:passengerId/lock/:type?"})} element={<AuthRoute component={PassengerLockByEmailForm} />} />
                <Route path={t({id: "/passenger/:passengerId/unlock/:type?"})} element={<AuthRoute component={PassengerUnlockByOtp} />} />
                <Route path={t({id: "/passenger/:passengerId/form/:type?"})} element={<AuthRoute component={PassengerFormPage} />} />
                <Route path={t({id: "/passenger/:passengerId/review/:type?"})} element={<AuthRoute component={PassengerReview} />} />
                <Route path={t({id: "/passenger/:passengerId/cc"})} element={<AuthRoute component={CardCapturePage} />} />
                <Route path={t({id: "/passenger/:passengerId/:type?"})} element={<AuthRoute component={PassengerOverview} />} />
                <Route path={t({id: "/covidSurvey"})} element={<AuthRoute component={CovidSurvey} />} />
                <Route path={t({id: "/immigrationCheck"})} element={<AuthRoute component={ImmigrationCheck} />} />
            </RouterRoutes>
        </PreCruiseProvider>
    )
}

export default PrecruiseRoutes;

function Default(props) {
    return (
        <div>
            Default precruise route
        </div>
    )
}